import { render, staticRenderFns } from "./PerformanceMetrics.vue?vue&type=template&id=46ea130a&scoped=true&"
import script from "./PerformanceMetrics.vue?vue&type=script&lang=js&"
export * from "./PerformanceMetrics.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceMetrics.vue?vue&type=style&index=0&id=46ea130a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ea130a",
  null
  
)

export default component.exports